<template>
    <div class="title">账号申诉</div>
    <div class="appeal_box">
        <div class="qrcode_box">
            <img class="qrcode" :src="'https://jianpin-oss.adnonstop.cn/jianpin-dh/resource/contact_code.png'" fit="cover" alt="">
        </div>
        <div class="appeal_txt">尊贵的简拼用户，请扫上方二维码<br/>加「简拼」客服微信来为您解决账号问题</div>
    </div>
</template>

<style lang="scss" scoped>
    .appeal_box{
        text-align: center;
        .qrcode_box{
            width: 200px;
            height: 200px;
            border-radius: 8px;
            border: 1px solid #E5E6EB;
            background: #FFF;
            padding: 15px;
            margin: 0 auto;
            margin-bottom: 12px;
            .qrcode{
                width: 100%;
                height: 100%;
            }
        }
        .appeal_txt{
            color:#4E5969;
            text-align: center;
            font-family: PingFang SC;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
        }
    }
</style>